import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'

export const ColSettings = () => {
  const widthOptions = [
    { label: '25%', value: '25' },
    { label: '33%', value: '33' },
    { label: '50%', value: '50' },
    { label: '66%', value: '66' },
    { label: '75%', value: '75' },
    { label: '100%', value: '100' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="width"
          type="select"
          options={widthOptions}
          label="Width"
          defaultValue={defaultProps['width']}
        />
      </ToolbarSection>
    </>
  )
}
